import {
    BuildInternalIcon,
    IconBuilding
} from '../../../components/buttons/IconButtons';
import CustomTooltip from '../../../components/CustomTooltip';
import CustomChip from '../../../components/CustomChip';
import { statusBorderColor, statusColor, statusFontColor } from '../../../enums/statusColorEnum';
import {status} from '../../../enums/statusEnum';
import {EMPTY_VALUES} from '../../../Apis/functions';
import React from "react";
import BuildingUsersResume from "./BuildingUsersResume";
/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 */
const BuildingInformation = ({
    t,
    buildingDetail,
    setUserClassificationSelected,
    setShowManagerUserListModal,
    containerHeight
}) => {
    const statusId = buildingDetail?.statusId;
    const {latitude, longitude} = buildingDetail || {};
    // The address only opens the map when the building has coordinates
    const hasCoordinates = !!latitude && !!longitude;

    /**
     * Opens the position of the building in google maps.
     *
     * @function openInMaps
     */
    const openInMaps = () => {
        if (!hasCoordinates) return;

        window.open(`https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`, '_blank');
    };

    return (
        <>
            <div className="border-full-shades-300 border-radius-8px d-flex flex-column overflow-hidden minh-645px" style={{height:containerHeight }}>
                <div className={"row"}>
                    <div className='d-flex justify-content-between align-items-center p-16px'>
                        <div className='d-flex align-items-center '>
                            <div><IconBuilding /></div>
                            <div className='ml-2'>
                                <CustomTooltip
                                    text={t("key_details")}
                                    classes={'font-color-general-950 ibl-font-w-600 fs-16px text-ellipsis-1-row'}
                                    showIfTruncated={true}
                                    placement={'top'}
                                />
                            </div>
                        </div>
                        <CustomChip
                            background={statusColor[statusId]}
                            fontColor={statusFontColor[statusId]}
                            borderColor={statusBorderColor[statusId]}
                            legend={t(status[statusId]) || EMPTY_VALUES.DEFAULT}
                            variant={'large'}
                        />
                    </div>
                </div>

                <div className='border-bottom-shades-300' />

                <div className='row align-items-start p-3'>
                    <div className='col-2 p-0'>
                        <div className='background-primary-100 p-8px border-radius-8px d-flex justify-content-center'>
                            <BuildInternalIcon/>
                        </div>
                    </div>
                    <div className='col-10'>
                        <div className={"row"}>
                            <CustomTooltip
                                text={t('building')}
                                classes={'font-color-general-950 ibl-font-w-600 fs-14px text-ellipsis-1-row p-0 mb-2'}
                                showIfTruncated={true}
                                placement={'top'}
                                tooltipClasses={"p-0"}
                            />

                            <CustomTooltip
                                text={buildingDetail?.name || EMPTY_VALUES.DEFAULT}
                                classes={`fs-14px font-color-general-950 text-ellipsis-1-row p-0`}
                                showIfTruncated={true}
                                tooltipClasses={"p-0"}
                            />
                        </div>

                        <div className='border-bottom-shades-300 my-3'/>

                        <div className={"row"}>
                            <p className='fs-14px ibl-font-w-600 p-0 mb-2'>{t('location')}</p>
                            <div
                                id={"lbl_bi_location"}
                                className={`p-0 ${hasCoordinates ? "cursor-pointer" : ""}`}
                                onClick={openInMaps}
                            >
                                <CustomTooltip
                                    text={buildingDetail?.location || EMPTY_VALUES.DEFAULT}
                                    classes={`fs-14px text-ellipsis-2-rows p-0 ${hasCoordinates ? "font-color-primary-700 font-hover-primary-900" : "font-color-general-950"}`}
                                    showIfTruncated={true}
                                    tooltipClasses={"p-0"}
                                />
                            </div>
                        </div>

                        <div className='border-bottom-shades-300 my-3'/>

                        <p className='fs-14px ibl-font-w-600 p-0'>{t('identity_verification')}</p>
                        <BuildingUsersResume
                            buildingDetail={buildingDetail}
                            setUserClassificationSelected={setUserClassificationSelected}
                            setShowManagerUserListModal={setShowManagerUserListModal}
                        />

                    </div>
                </div>
            </div>
        </>
    );
};

export default BuildingInformation;
